import { FC } from 'react'

import BannerImage from './banner-image/banner-image'
import BannerContent from './banner-content/banner-content'

import { IBannerContent } from './banner-content/data'
import { IBannerImage } from './banner-image/data'

import styles from 'styles/course/course.module.scss'

interface IBanner {
  clickHandler: () => void
  contentData: IBannerContent
  imgData: IBannerImage
  isNotAuthorized: boolean
  lectorsMod?: string
}

const Banner: FC<IBanner> = ({
  clickHandler,
  contentData,
  imgData,
  lectorsMod,
  isNotAuthorized,
}) => {
  return (
    <div className={styles.layoutWrapper}>
      <div className={styles.mainContent}>
        <BannerContent
          scrollHandler={clickHandler}
          isNotAuthorized={isNotAuthorized}
          {...contentData}
          lectorsMod={lectorsMod}
        />
      </div>
      <BannerImage {...imgData} />
    </div>
  )
}

export default Banner
